import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EditableContentComponent } from './editable-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MenuModule } from '@caslink/common-client/ng-app/menu/menu.module';

@NgModule({
  declarations: [EditableContentComponent],
  entryComponents: [EditableContentComponent],
  exports: [EditableContentComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MenuModule,
  ],
})
export class EditableContentModule {}
